const routes = [
	{
		path: '/soluciones',
		component: () => import('@/views/dashboard/solutions/List.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/agregar/solucion',
		component: () => import('@/views/dashboard/solutions/Add.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/solucion/:name',
		component: () => import('@/views/dashboard/solutions/Edit.vue'),
		meta: {
			auth: true
		}
	}
];

export default routes;